module.exports = __webpack_public_path__ + "img/mobile1.b935dc14.png";